import React from 'react';
import { observer } from 'mobx-react-lite';
import { isMobile, TopWinnersContainer } from '@pascal/pascal-core';

import { ResultsWrapper } from '../resultsWrapper';
import { CurrentAndTopWinnersItem } from '../topWinnersItem';

export const ResultTopWinContainer = observer(() => {
  return isMobile() ? (
    <TopWinnersContainer
      renderCurrentOrTopWinnerItem={(betData) => (
        <CurrentAndTopWinnersItem betData={betData} key={JSON.stringify(betData)} />
      )}
    />
  ) : (
    <ResultsWrapper />
  );
});
